import { Injectable } from '@angular/core';
import * as cartItemActions from '@features/cart-item/actions/cart-item.actions';
import * as userPreferenceActions from '@features/user-preference/store/actions/user-preference.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { FeatureFlagService } from '@rd/core/services/feature-flag/feature-flag.service';
import { FeatureFlags } from '@rd/types';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class AnzShoppingCartUserPreferenceEffects {
  constructor(
    private actions$: Actions,
    private featureFlagService: FeatureFlagService,
  ) {}

  updatePointsAccountIdForShoppingCartSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        userPreferenceActions.UserPreferenceActionTypes
          .UPDATE_POINTS_ACCOUNT_ID_SUCCESS,
      ),
      filter(() => this.featureFlagService.isEnable(FeatureFlags.ShoppingCart)),
      map(() => cartItemActions.LoadCart()),
    ),
  );
}
